var map = {
	"./Group 4 Copy 5": 7,
	"./Group 4 Copy 5.jpg": 7,
	"./add-resource-placeholder": 8,
	"./add-resource-placeholder.svg": 8,
	"./arrow": 9,
	"./arrow.svg": 9,
	"./attachement-preview": 10,
	"./attachement-preview-02": 11,
	"./attachement-preview-02.jpg": 11,
	"./attachement-preview-03": 12,
	"./attachement-preview-03.jpg": 12,
	"./attachement-preview.jpg": 10,
	"./avatar": 13,
	"./avatar.svg": 13,
	"./chat-bubble": 14,
	"./chat-bubble.svg": 14,
	"./dotted-border": 15,
	"./dotted-border.svg": 15,
	"./downvote": 16,
	"./downvote.svg": 16,
	"./fire-full-icon": 17,
	"./fire-full-icon.svg": 17,
	"./fire-gap-icon": 18,
	"./fire-gap-icon.svg": 18,
	"./focus-dimension-sample-image-thumb": 19,
	"./focus-dimension-sample-image-thumb.jpg": 19,
	"./focus-example-form": 20,
	"./focus-example-form.jpg": 20,
	"./focus-wheel-example": 21,
	"./focus-wheel-example.jpg": 21,
	"./focus-wheel-intro": 22,
	"./focus-wheel-intro.svg": 22,
	"./habit-icon": 23,
	"./habit-icon.svg": 23,
	"./intro-profile-pic": 24,
	"./intro-profile-pic.svg": 24,
	"./logo": 25,
	"./logo.svg": 25,
	"./quotation-mark": 26,
	"./quotation-mark.svg": 26,
	"./reflections-icon": 27,
	"./reflections-icon.svg": 27,
	"./resource-placeholder": 28,
	"./resource-placeholder.svg": 28,
	"./resource-placeholder01": 29,
	"./resource-placeholder01.jpg": 29,
	"./resource-placeholder02": 30,
	"./resource-placeholder02.jpg": 30,
	"./resource-placeholder03": 31,
	"./resource-placeholder03.jpg": 31,
	"./resource-placeholder04": 32,
	"./resource-placeholder04.jpg": 32,
	"./resource-placeholder05": 33,
	"./resource-placeholder05.jpg": 33,
	"./resource-placeholder06": 34,
	"./resource-placeholder06.jpg": 34,
	"./resource-placeholder07": 35,
	"./resource-placeholder07.jpg": 35,
	"./resources-folder": 36,
	"./resources-folder.svg": 36,
	"./resources-item-new": 37,
	"./resources-item-new.svg": 37,
	"./resources-new-folder": 38,
	"./resources-new-folder.svg": 38,
	"./slider-end": 39,
	"./slider-end.svg": 39,
	"./smile-1": 40,
	"./smile-1.svg": 40,
	"./smile-2": 41,
	"./smile-2.svg": 41,
	"./smile-3": 42,
	"./smile-3.svg": 42,
	"./smile-4": 43,
	"./smile-4.svg": 43,
	"./smile-5": 44,
	"./smile-5.svg": 44,
	"./spark-line-flag": 45,
	"./spark-line-flag.png": 45,
	"./star": 46,
	"./star.svg": 46,
	"./team-icon": 47,
	"./team-icon.svg": 47,
	"./trophy": 48,
	"./trophy.svg": 48,
	"./updates-icon": 49,
	"./updates-icon.svg": 49,
	"./upvote": 50,
	"./upvote.svg": 50,
	"./whats-next-icon": 51,
	"./whats-next-icon.svg": 51
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56;